"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ThemeProvider = require("../../../ThemeProvider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TwitterIcon =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TwitterIcon, _React$Component);

  function TwitterIcon() {
    _classCallCheck(this, TwitterIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(TwitterIcon).apply(this, arguments));
  }

  _createClass(TwitterIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          fill = _this$props.fill;
      return _react["default"].createElement("div", {
        className: this.props.theme.twitterIconCircle
      }, _react["default"].createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 18 17"
      }, _react["default"].createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: fill
      }, _react["default"].createElement("g", {
        transform: "translate(-248.000000, -227.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(230.000000, 30.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(0.000000, 68.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(5.000000, 31.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(0.000000, 54.000000)"
      }, _react["default"].createElement("g", {
        transform: "translate(0.000000, 29.000000)"
      }, _react["default"].createElement("path", {
        d: "M30.503706,15.27756 C29.789674,15.71136 28.998752,16.026198 28.157362,16.196856 C27.483832,15.459486 26.52494,15 25.462604,15 C23.422764,15 21.769398,16.696626 21.769398,18.787398 C21.769398,19.084002 21.802354,19.373136 21.86501,19.650066 C18.796318,19.49226 16.075314,17.984058 14.253978,15.69264 C13.93599,16.250946 13.75471,16.901862 13.75471,17.59641 C13.75471,18.910788 14.407186,20.070222 15.396988,20.748588 C14.791702,20.72796 14.222738,20.557302 13.724482,20.27292 L13.724482,20.320188 C13.724482,22.155432 14.997622,23.685378 16.686078,24.0351 C16.376824,24.120744 16.050674,24.16785 15.713458,24.16785 C15.474934,24.16785 15.244286,24.142794 15.018038,24.099018 C15.488222,25.60326 16.851474,26.698758 18.466802,26.73033 C17.203562,27.745584 15.61063,28.350672 13.881144,28.350672 C13.58278,28.350672 13.288992,28.33242 13,28.29849 C14.634644,29.372424 16.574582,30.00003 18.66071,30.00003 C25.452836,30.00003 29.16681,24.228438 29.16681,19.223736 L29.154798,18.732678 C29.878598,18.20103 30.505862,17.533914 31.000246,16.774818 C30.337804,17.076012 29.627116,17.28015 28.88004,17.371662 C29.642472,16.902816 30.226902,16.159416 30.503706,15.27756 Z",
        id: "icon_twitter"
      }))))))))));
    }
  }]);

  return TwitterIcon;
}(_react["default"].Component);

_defineProperty(TwitterIcon, "propTypes", {
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  fill: _propTypes["default"].string
});

_defineProperty(TwitterIcon, "defaultProps", {
  width: '18',
  height: '15',
  fill: '#FFF'
});

var _default = (0, _ThemeProvider.applyTheme)('TwitterIcon', TwitterIcon);

exports["default"] = _default;